import {
  DocumentCmp,
  // AccessCmp,
  ErrorQuestionCmp,
  MainContentCmp,
  ReferenceCmp,
  CostWarningCmp,
  AgentVegaChartAsync,
  // ThinkCmp,
} from '@/pages/aigc/pages/Agent/ChatPage/components/SubComp';
import React, { memo } from 'react';
import { ThinkCmp } from './CopilotThinkCmp';
import { AccessCmp } from './CopilotAccessCmp';
import { DataDescriptionCmp } from '../../../../ChatPage/components/SubComp/DataDescriptionCmp';
import AgentEchart from '../../../../ChatPage/components/AgentEchart';
import { OpinionReportCardCmp } from '../../../../ChatPage/components/SubComp/OpinionReportCardCmp';
import KnowledgeCitation from '../../../../ChatPage/components/KnowledgeCitation';

// 基于上述子组件，根据服务端流式返回的分块按顺序加载渲染
export const CopilotSortCompChild = (props: any) => {
  const { answer } = props || {};
  const mapKey = {
    think: <ThinkCmp />,
    // 调整为从正文中插入图表，这个组件先注释，但是数据从biData读取
    // biData: <ChartCmp />,
    echartsOption: <AgentEchart />,
    text: <MainContentCmp />,
    reference: <ReferenceCmp />,
    error: <ErrorQuestionCmp />,
    document: <DocumentCmp />,
    sensitiveInfo: <AccessCmp />,
    costWarning: <CostWarningCmp />,
    data_description: <DataDescriptionCmp />,
    complete_summary: <DataDescriptionCmp />,
    bq_chart: <AgentVegaChartAsync />,
    opinion_report_card: <OpinionReportCardCmp />,
    database_query: <KnowledgeCitation />,
  };
  return (
    <div>
      {answer?.map((item: any, index: number) => {
        const comp = mapKey?.[item.type as keyof typeof mapKey];
        if (!comp) {
          return null;
        }
        // TODO: 样式调整待定
        return (
          <div
            key={index}
            style={{
              padding: '0px 0',
            }}
          >
            {<comp.type key={index} {...{ ...props, ...item, index, from: 'copilot', chartHeight: 206 }} />}
          </div>
        );
      })}
    </div>
  );
};

// 单独缓存 SortCompChild 的组件，避免对话 n-1 的数据都重新渲染
export const MemoizedCopilotSortCompChild = memo(
  CopilotSortCompChild,
  (prevProps, nextProps) =>
    prevProps.messageId === nextProps.messageId &&
    !nextProps.isLastQA &&
    prevProps.isLastQA === nextProps.isLastQA,
);
